import { BREADCRUMBS_PARTS, SCHEMA_TYPE } from '@/constants/schema';

export const getBreadcrumbSchema = (props) => {
  const { product, storeUrl, collectionItems } = props || {};
  if (!product || !storeUrl) return [];

  const breadCrumbParts = [
    BREADCRUMBS_PARTS.home,
    BREADCRUMBS_PARTS.collection,
    BREADCRUMBS_PARTS.category,
  ];
  const categoryName = product?.category?.name;
  const categoryId = product?.category?.id;
  const collectionURL = product?.collections
    ? `${storeUrl}/collections/${product?.collections?.[0]?.id || '0'}`
    : null;
  const categoryUrl = product?.category
    ? `${storeUrl}/collections/${product?.collections?.[0]?.id || '0'}?cid=${categoryId}`
    : null;
  const categoryUrl2 = `${storeUrl}/shop/${categoryName}?cid=${categoryId}`;

  const getBreadcrumbSchemaPart = (part) => {
    const itemList = [
      {
        '@type': SCHEMA_TYPE.LIST_ITEM,
        position: 1,
        name: 'Home',
        item: storeUrl,
      },
    ];

    if (collectionURL && part === BREADCRUMBS_PARTS.collection) {
      itemList.push({
        '@type': SCHEMA_TYPE.LIST_ITEM,
        position: 2,
        name: product?.collections?.[0]?.name || 'Other Collections',
        item: collectionURL,
      });
    }

    if (
      categoryUrl &&
      (part === BREADCRUMBS_PARTS.category || part === BREADCRUMBS_PARTS.collection)
    ) {
      itemList.push({
        '@type': SCHEMA_TYPE.LIST_ITEM,
        position: itemList.length + 1,
        name: categoryName,
        item: part === BREADCRUMBS_PARTS.category ? categoryUrl2 : categoryUrl,
      });
    }

    itemList.push({
      '@type': SCHEMA_TYPE.LIST_ITEM,
      position: itemList.length + 1,
      name: product?.name || 'Product',
    });
    return itemList;
  };

  const breadCrumbSchema = breadCrumbParts
    .map((schema) => {
      if (schema === BREADCRUMBS_PARTS.collection && !collectionItems?.length)
        return null;

      const itemList = getBreadcrumbSchemaPart(schema);

      return {
        '@context': 'https://schema.org',
        '@type': SCHEMA_TYPE.BreadcrumbList,
        itemListElement: itemList,
      };
    })
    .filter((schema) => schema);

  return breadCrumbSchema;
};
